import Logo from '../src/Logo';
export default Logo;
